export const beforeUnloadHandler = (e) => {
  e.preventDefault();
  e.returnValue = "";
};
